module.exports = __webpack_public_path__ + "img/Logo Recursos Humanos.ef3bea68.webp";